var _rect, _circle, _path, _path2, _circle2, _g, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgErrorIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 239,
    height: 130,
    viewBox: "0 0 239 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_128_1074)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_128_1074)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 238.593,
    height: 129.973,
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 73.3755,
    cy: 83.8335,
    r: 20.852,
    fill: "#FFE299"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M152.631 58.4756C127.284 58.4756 105.956 76.7711 99.6793 101.624C97.6079 109.826 104.665 116.791 113.125 116.791H192.136C200.596 116.791 207.653 109.826 205.582 101.624C199.306 76.7711 177.977 58.4756 152.631 58.4756Z",
    fill: "#FFE299"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M99.4516 16.7265C102.668 11.1562 110.708 11.1562 113.924 16.7265L164.209 103.824C167.425 109.394 163.405 116.357 156.973 116.357H56.4017C49.9697 116.357 45.9497 109.394 49.1657 103.824L99.4516 16.7265Z",
    fill: "#E74023"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_128_1074",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 127,
    y: 25,
    width: 47,
    height: 46
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 150.562,
    cy: 48.3035,
    r: 22.6737,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_128_1074)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 150.562,
    cy: 48.3035,
    r: 22.6737,
    fill: "#FBC69D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150.992,
    cy: 31.9793,
    r: 21.7528,
    fill: "#2B303B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 177.555,
    cy: 48.533,
    r: 21.7528,
    fill: "#2B303B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 158.948,
    cy: 57.6717,
    r: 5.30554,
    fill: "#FBC69D"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M110.685 45.3915V77.3644C110.685 79.6125 108.811 81.361 106.688 81.361C104.44 81.361 102.691 79.6125 102.691 77.3644V45.3915C102.691 43.2684 104.44 41.3949 106.688 41.3949C108.811 41.3949 110.685 43.2684 110.685 45.3915ZM106.688 97.3474C104.815 97.3474 103.191 96.4732 102.317 94.8496C101.442 93.3508 101.442 91.4774 102.317 89.8538C103.191 88.3551 104.815 87.3559 106.688 87.3559C108.437 87.3559 110.06 88.3551 110.934 89.8538C111.809 91.4774 111.809 93.3508 110.934 94.8496C110.06 96.4732 108.437 97.3474 106.688 97.3474Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M136.397 95.5259L155.622 95.6044L174.341 103.553L174.341 116.832L158.209 116.832C152.771 116.832 148.119 112.927 147.178 107.571L146.258 102.341L140.301 101.441C137.502 101.018 135.686 98.2652 136.397 95.5259Z",
    fill: "#FBC69D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6433 51.9329L79.0026 58.2367C80.5356 59.1695 81.0221 61.1685 80.0892 62.7016L74.2925 72.2275C72.027 75.9506 67.1723 77.1321 63.4492 74.8666L57.0554 70.9758L68.6433 51.9329Z",
    fill: "#FBC69D"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_128_1074"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 238.593,
    height: 129.973,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_128_1074"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 238.593,
    height: 129.973,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/errorIcon.0a8880a196855633d341f532ebfaeab5.svg";
export { ForwardRef as ReactComponent };